import { render, staticRenderFns } from "./GoodsAction.vue?vue&type=template&id=06174ea8&scoped=true&"
import script from "./GoodsAction.vue?vue&type=script&lang=js&"
export * from "./GoodsAction.vue?vue&type=script&lang=js&"
import style0 from "./GoodsAction.vue?vue&type=style&index=0&id=06174ea8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06174ea8",
  null
  
)

export default component.exports